import React, { useState } from "react";
import moment from "moment";
import ChatHistoryModal from "../../../../Utility/Components/ChatHistoryModal";
import ModalGlobal from "../../../../Utility/Components/ModalGlobal";
import ErrorBoundary from "../../../../Utility/Components/ErrorBoundary";
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { saveActivity, updateTask, addNoteListing } from '../Controller/DashboardController';
import Utility from "../../../../Utility/Utility";

const TaskListPopup = ({ showTaskPopup, popupTask, mousePosition, onClose, history, tabGridLabel, loaderStateTrue, loaderStateFalse, localTimeZoneName, refreshTaskData }) => {

    const [chatHistoryModalFlag, setchatHistoryModalFlag] = useState(false);
    const [taskListData, setTaskListData] = useState(null);

    // Add Activity Modal states
    const [addTaskModal, setAddTaskModal] = useState(false);
    const [nextAction, setNextAction] = useState("");
    const [nextActionError, setNextActionError] = useState("");
    const [nextActionDate, setNextActionDate] = useState("");
    const [nextActionDateError, setNextActionDateError] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    // Mark as dropdown states
    const [markAsSelection, setMarkAsSelection] = useState("");
    const [showAddNoteButton, setShowAddNoteButton] = useState(false);

    // Note functionality states
    const [showNoteTextarea, setShowNoteTextarea] = useState(false);
    const [noteContent, setNoteContent] = useState("");
    const [isSavingNote, setIsSavingNote] = useState(false);

    if (!showTaskPopup || !popupTask) {
        return null;
    }

    // Calculate tooltip position with viewport boundary checks
    const getTooltipStyle = () => {
        const tooltipWidth = 400;
        const tooltipHeight = 500;
        const offset = 10;

        let left = mousePosition.x + offset;
        let top = mousePosition.y + offset;

        // Check right boundary
        if (left + tooltipWidth > window.innerWidth) {
            left = mousePosition.x - tooltipWidth - offset;
        }

        // Check bottom boundary
        if (top + tooltipHeight > window.innerHeight) {
            top = mousePosition.y - tooltipHeight - offset;
        }

        // Ensure tooltip doesn't go off-screen
        left = Math.max(10, left);
        top = Math.max(10, top);

        return {
            position: 'fixed',
            left: `${left}px`,
            top: `${top}px`,
            zIndex: 9999,
            width: `${tooltipWidth}px`,
            maxHeight: `${tooltipHeight}px`
        };
    };

    // Map contact_status to appropriate tab name (matches globaltabIndexMap)
    const statusToTabMap = {
        0: 'chathistory',           // Leads
        1: 'opportunity',           // Opportunity  
        2: 'futureopportunity',     // Future Opportunity
        3: 'inactive',              // Inactive
        4: 'salespipeline4',        // Sales Pipeline 4
        5: 'salespipeline5',        // Sales Pipeline 5
        6: 'salespipeline6',        // Sales Pipeline 6
        7: 'salespipeline7',        // Sales Pipeline 7
        8: 'salespipeline8',        // Sales Pipeline 8
        9: 'salespipeline9',        // Sales Pipeline 9
        10: 'salespipeline10',      // Sales Pipeline 10
        11: 'ad-hocmessages',       // Ad-hoc Messages
        12: 'transactionalMessages', // Transactional Messages
        '-1': 'sentMessages'         // Default to chathistory for -1 or any other value
    };

    const redirectToNotificationTab = (contact_number, contact_status) => {
        if (history) {
            // Get the appropriate tab name based on contact_status, default to 'chathistory'
            const selectedTabName = statusToTabMap[contact_status] || 'chathistory';

            history.push(`/${localStorage.getItem('i18nextLng')}/chat`);
            localStorage.setItem("selectedTabName", selectedTabName);
            localStorage.setItem("setSearchField", contact_number);
        }
    }

    const openChat = (task) => {
        setTaskListData(task)
        setchatHistoryModalFlag(true);
    }

    const chatHistoryModalClose = () => {
        setchatHistoryModalFlag(false);
    }

    // Add Activity Modal functions
    const addTaskModalHideFn = () => {
        setAddTaskModal(false);
        setNextAction("");
        setNextActionError("");
        setNextActionDate("");
        setNextActionDateError("");
        setIsSaving(false);
    }

    const addTaskModalSaveFn = async () => {
        let isValid = true;

        // Validate Next Action
        if (nextAction.trim() === "") {
            setNextActionError("Next Action is required");
            isValid = false;
        } else {
            setNextActionError("");
        }

        // Validate Next Action Date
        if (nextActionDate.trim() === "") {
            setNextActionDateError("Next Action Date & Time is required");
            isValid = false;
        } else {
            setNextActionDateError("");
        }

        if (isValid) {
            setIsSaving(true);
            loaderStateTrue();

            try {
                // Prepare data for API call
                const activityData = {
                    customer_id: popupTask.customer_id || null,
                    account_id: popupTask.account_id || null,
                    next_action: nextAction,
                    next_action_date: nextActionDate,
                    status: 'Pending',
                    notes: "",
                    timezone: localTimeZoneName
                };

                // console.log("Saving activity:=========", activityData);
                // return;

                // Make API call
                const response = await saveActivity(activityData);
                if (response && response.success) {
                    Utility.toastNotifications(response.message || "Created successfully", "Success", "success");
                    // Update the task list with the new task data
                    const newTask = {
                        id: response.data?.id || null,
                        customer_id: response.data?.customer_id || null,
                        next_action: response.data?.next_action || null,
                        next_action_date: response.data?.next_action_date || null,
                        status: response.data?.status || null,
                    };

                    // Refresh the calendar data after successful save
                    if (window.wrappedRefreshTaskData) {
                        window.wrappedRefreshTaskData();
                    } else if (refreshTaskData) {
                        refreshTaskData();
                    }

                    // Close modal after successful save
                    addTaskModalHideFn();
                } else {
                    console.error("Failed to save activity:", response);
                }

            } catch (error) {
                console.error("Error saving activity:", error);
            } finally {
                setIsSaving(false);
                loaderStateFalse();
            }
        }
    }

    const nextActionFn = (e) => {
        setNextAction(e.target.value);
        if (e.target.value.trim() !== "") {
            setNextActionError("");
        }
    }

    const nextActionDateFn = (value) => {
        setNextActionDate(value);
        if (value.trim() !== "") {
            setNextActionDateError("");
        }
    }

    const tabOriginalName = (status) => {
        // Get the tab name for the given status
        const tabName = statusToTabMap[status];

        const dataset = tabGridLabel?.filter(item =>
            item.ui_element_type.includes("tab") &&
            item.screen_name === "notification history" &&
            item.setting_data?.some(setting => setting.field_name === tabName)
        );

        // Find the specific setting data for the tabName and return modified_field_caption
        if (dataset && dataset.length > 0) {
            const settingData = dataset[0].setting_data?.find(setting => setting.field_name === tabName);
            return settingData?.modified_field_caption || tabName;
        }

        return tabName; // fallback to original tabName if not found
    };

    const refreshTableData = () => {
        // Refresh the calendar data after successful save
        if (window.wrappedRefreshTaskData) {
            window.wrappedRefreshTaskData();
        } else if (refreshTaskData) {
            refreshTaskData();
        }
    }

    // Handle dropdown change for Mark as
    const handleMarkAsChange = async (e) => {
        const selectedValue = e.target.value;
        setMarkAsSelection(selectedValue);

        const task_id = popupTask.id;
        const updateData = {
            status: selectedValue
        };

        const response = await updateTask(task_id, updateData);

        loaderStateTrue();
        if (response.success) {
            Utility.toastNotifications(response?.message || "Task status updated successfully", "Success", "success");
            refreshTableData();
            // Show Add Note button if user selects skip or complete
            if (selectedValue === "Skip" || selectedValue === "Complete") {
                setShowAddNoteButton(true);
            } else {
                setShowAddNoteButton(false);
            }
        } else {
            Utility.toastNotifications(response?.message || "Failed to update task status", "Error", "error");
            resetDropdownValues();
        }
        loaderStateFalse();
    };

    // Handle Add Note button click
    const handleAddNoteClick = () => {
        setShowNoteTextarea(true);
    };

    // Handle note content change
    const handleNoteContentChange = (e) => {
        setNoteContent(e.target.value);
    };

    // Handle save note
    const handleSaveNote = async () => {
        if (!noteContent.trim()) {
            Utility.toastNotifications("Please enter a note before saving", "Warning", "warning");
            return;
        }

        setIsSavingNote(true);
        loaderStateTrue();

        try {
            const task_id = popupTask.id;
            const noteData = [
                {
                    "customer_phone_number": popupTask.contact_number,
                    "content": noteContent.trim(),
                    "crm_followup_id": task_id
                }
            ];

            console.log("Saving note:", noteData);
            // return;

            const response = await addNoteListing(noteData);

            if (response[0].success) {
                Utility.toastNotifications(response?.[0]?.message || "Note saved successfully", "Success", "success");
                refreshTableData();
                // Reset note states
                setShowNoteTextarea(false);
                setNoteContent("");
                onCloseFn();
            } else {
                Utility.toastNotifications(response?.message || "Failed to save note", "Error", "error");
            }
        } catch (error) {
            console.error("Error saving note:", error);
            Utility.toastNotifications("Failed to save note", "Error", "error");
        } finally {
            setIsSavingNote(false);
            loaderStateFalse();
        }
    };

    // Handle cancel note
    const handleCancelNote = () => {
        setShowNoteTextarea(false);
        setNoteContent("");
    };

    // Reset dropdown values when tooltip closes
    const resetDropdownValues = () => {
        setMarkAsSelection("");
        setShowAddNoteButton(false);
        setShowNoteTextarea(false);
        setNoteContent("");
        setIsSavingNote(false);
    };

    const onCloseFn = () => {
        resetDropdownValues();
        onClose();
    };

    const formatTaskDate = (dateString) => {
        if (!dateString) return "";
        return moment.utc(dateString).format("DD MMM, YYYY HH:mm:ss");
    };

    return (
        <>
            <div className="task-tooltip-overlay" onClick={onCloseFn}>
                <div
                    className="task-tooltip-container"
                    style={getTooltipStyle()}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Tooltip Header */}
                    <div className="task-tooltip-header">
                        <h4 className="task-tooltip-title">
                            📋 {popupTask.account_name}
                        </h4>
                        <button
                            className="task-tooltip-close"
                            onClick={onCloseFn}
                        >
                            ×
                        </button>
                    </div>

                    {/* Tooltip Content */}
                    <div className="task-tooltip-content">

                        {/* Task Details Block */}
                        <div className="task-tooltip-section">
                            <div className="task-tooltip-section-title">
                                <span>📝 Activity Details</span>
                                {/* <button
                                    className="task-tooltip-add-activity-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setAddTaskModal(true);
                                    }}
                                >
                                    + Add Activity
                                </button> */}
                            </div>
                            <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Date:</span>
                                <span className="task-tooltip-text">{moment.utc(popupTask.task_date).format("DD MMM, YYYY HH:mm:ss")}</span>
                            </div>
                            <div className="task-tooltip-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="task-tooltip-label">Status:</span>
                                    <span className={`task-tooltip-badge status-${popupTask.task_status?.toLowerCase()}`}>
                                        {popupTask.task_status || 'Pending'}
                                    </span>
                                </div>
                                <div className="task-mark-as-container">
                                    <div className="task-mark-as-section">
                                        <span className="task-tooltip-label task-mark-as-label">Mark as:</span>
                                        {!markAsSelection ? (
                                            <select
                                                value={markAsSelection}
                                                onChange={handleMarkAsChange}
                                                className="task-mark-as-dropdown"
                                            >
                                                <option value="">Select</option>
                                                <option value="Skip">Skip</option>
                                                <option value="Complete">Complete</option>
                                            </select>
                                        ) : (
                                            <div className={`task-mark-as-selected ${markAsSelection.toLowerCase()}`}>
                                                <i className={`fa ${markAsSelection === 'Skip' ? 'fa-forward' : 'fa-check'} task-mark-as-icon`}></i>
                                                <span>{markAsSelection}</span>
                                            </div>
                                        )}
                                    </div>
                                    {/* {showAddNoteButton && ( */}
                                    <button
                                        onClick={handleAddNoteClick}
                                        className="task-add-note-btn"
                                    >
                                        Add Note
                                    </button>
                                    {/* )} */}
                                </div>
                            </div>
                            {showNoteTextarea && (
                                <div className="task-tooltip-row full-width">
                                    <div className="task-note-input-section">
                                        <span className="task-tooltip-label">Add Note:</span>
                                        <textarea
                                            value={noteContent}
                                            onChange={handleNoteContentChange}
                                            placeholder="Enter your note here..."
                                            className="task-note-textarea"
                                            rows={3}
                                        />
                                        <div className="task-note-buttons">
                                            <button
                                                onClick={handleSaveNote}
                                                disabled={isSavingNote}
                                                className="task-note-save-btn"
                                            >
                                                {isSavingNote ? "Saving..." : "Save"}
                                            </button>
                                            <button
                                                onClick={handleCancelNote}
                                                disabled={isSavingNote}
                                                className="task-note-cancel-btn"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="task-tooltip-row full-width">
                                <span className="task-tooltip-label">Task:</span>
                                <p className="task-tooltip-desc-text">{popupTask.task}</p>
                            </div>
                            {popupTask.crm_notes.length > 0 && (
                                <div className="task-tooltip-row full-width">
                                    <span className="task-tooltip-label">Notes:</span>
                                    <div className="task-notes-container">
                                        {(() => {
                                            // Parse notes string to extract individual notes
                                            /* const parseNotes = (notesString) => {
                                                if (!notesString) return [];

                                                // Split by newline and filter out empty lines
                                                const noteLines = notesString.split('\n').filter(line => line.trim());

                                                return noteLines.map(line => {
                                                    // Extract timestamp and content using regex
                                                    const match = line.match(/^\[([^\]]+)\]\s*(.+)$/);
                                                    if (match) {
                                                        const [, timestamp, content] = match;
                                                        return {
                                                            timestamp: timestamp.trim(),
                                                            content: content.trim()
                                                        };
                                                    }
                                                    // If no timestamp pattern found, treat entire line as content
                                                    return {
                                                        timestamp: null,
                                                        content: line.trim()
                                                    };
                                                });
                                            }; */

                                            // const parsedNotes = parseNotes(popupTask.notes);
                                            if (popupTask.crm_notes.length > 0) {
                                                const parsedNotes = popupTask.crm_notes;

                                                return parsedNotes.map((note, index) => {
                                                    const commentedDate = formatTaskDate(note.commented_at);
                                                    return (
                                                        <div key={index} className="task-note-block">
                                                            <div className="task-note-content">
                                                                {note.content}
                                                            </div>
                                                            {note.commented_at && (
                                                                <div className="task-note-timestamp">
                                                                    🕐 {commentedDate}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                });
                                            }
                                        })()}
                                    </div>
                                </div>
                            )}
                            <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Task owner:</span>
                                <span className={`task-tooltip-text`}>
                                    {popupTask.task_owner || ''}
                                </span>
                            </div>
                        </div>
                        {/* Contact Information Block */}
                        <div className="task-tooltip-section">
                            <div className="task-tooltip-section-title">
                                👤 Contact Information
                            </div>
                            <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Name:</span>
                                <span className="task-tooltip-text">{popupTask.contact_name}</span>
                            </div>
                            <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Phone:</span>
                                <span
                                    className="task-tooltip-phone-link"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        redirectToNotificationTab(popupTask.contact_number, popupTask.contact_status);
                                    }}
                                >
                                    {popupTask.contact_number}
                                </span>
                                {popupTask.has_whatsapp && <span className="task-tooltip-badge whatsapp" onClick={() => { openChat(popupTask) }}> <img src={require('../../../../Utility/Public/images/whatsapp1.png')} style={{ height: "13px" }} className="whatsapp_icon" /></span>}
                            </div>
                            {popupTask.contact_email && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Email:</span>
                                    <span>{popupTask.contact_email}</span>
                                </div>
                            )}
                            {(popupTask.contact_address1 || popupTask.contact_address2 || popupTask.contact_address3) && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Address:</span>
                                    <span className="task-tooltip-text">
                                        {[popupTask.contact_address1, popupTask.contact_address2, popupTask.contact_address3]
                                            .filter(Boolean).join(", ")}
                                    </span>
                                </div>
                            )}
                            {popupTask.hasOwnProperty("contact_status") ? (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Stage:</span>
                                    <span className="task-tooltip-badge subscribed">{tabOriginalName(popupTask.contact_status)}</span>
                                </div>
                            ) : null}
                            {/* <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Status:</span>
                                <span className={`task-tooltip-badge ${popupTask.is_subscribed ? 'subscribed' : 'unsubscribed'}`}>
                                    {popupTask.is_subscribed ? '✓ Subscribed' : '✗ Unsubscribed'}
                                </span>
                            </div> */}
                        </div>

                        {/* Account Information Block */}
                        <div className="task-tooltip-section">
                            <div className="task-tooltip-section-title">
                                🏢 Account Information
                            </div>
                            <div className="task-tooltip-row">
                                <span className="task-tooltip-label">Company:</span>
                                <span className="task-tooltip-text">{popupTask.account_name}</span>
                            </div>
                            {popupTask.account_phone_number && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Phone:</span>
                                    <span>
                                        {popupTask.account_phone_number}
                                    </span>
                                </div>
                            )}
                            {popupTask.account_email && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Email:</span>
                                    <span>{popupTask.account_email}</span>
                                </div>
                            )}
                            {popupTask.account_website && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Website:</span>
                                    <a
                                        href={popupTask.account_website.startsWith('http') ? popupTask.account_website : `https://${popupTask.account_website}`}
                                        className="task-tooltip-website-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {popupTask.account_website}
                                    </a>
                                </div>
                            )}
                            {popupTask.account_industry && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Industry:</span>
                                    <span className="task-tooltip-text">{popupTask.account_industry}</span>
                                </div>
                            )}
                            {popupTask.account_address && (
                                <div className="task-tooltip-row">
                                    <span className="task-tooltip-label">Address:</span>
                                    <span className="task-tooltip-text">
                                        {[popupTask.account_address, popupTask.account_city, popupTask.account_state, popupTask.account_country, popupTask.account_postal_code]
                                            .filter(Boolean).join(", ")}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={chatHistoryModalFlag}
                    onHide={chatHistoryModalClose}
                    className={`modalcustomize mondimension modalWithGrid chatModal chatHistoryModalDialog chatHistoryModalCommon`}
                    footer={true}
                    closeButton={true}
                    saveShow={false}
                    // zoominButton={zoominzoomoutflag != "" ? false : true}
                    // zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    // zoomin={zoominFunction}
                    // zoomout={zoomoutFunction}
                    // liveChat={false}
                    body={<>
                        <ChatHistoryModal gridPhoneNumber={taskListData?.contact_number} globalChatName={taskListData?.contact_name} lastChatInitiatedAt={taskListData?.last_chat_initiated_at || ""} />
                    </>}
                    cancelShow={false}

                />
            </ErrorBoundary>

            {/* ========add activity modal===== */}
            <ErrorBoundary title="Add Activity Modal Error">
                <ModalGlobal
                    show={addTaskModal}
                    onHide={!isSaving ? addTaskModalHideFn : undefined}
                    title={"Add Activity"}
                    className={`modalcustomize mondimension actionTaskDialog`}
                    footer={true}
                    closeButton={!isSaving}
                    saveShow={true}
                    cancelShow={true}
                    saveButtonLabel={isSaving ? "Saving..." : "Save"}
                    saveButtonClassName={`modbtn savebtn ${isSaving ? 'disabled' : ''}`}
                    onSave={!isSaving ? addTaskModalSaveFn : undefined}
                    onCancel={!isSaving ? addTaskModalHideFn : undefined}
                    cancelButtonClassName={`modbtn cancelbtn ${isSaving ? 'disabled' : ''}`}
                    liveChat={false}
                    body={
                        <div className="actionTaskInner">
                            <div className="form-group">
                                <label>Next Action</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={nextAction}
                                    onChange={(e) => nextActionFn(e)}
                                />
                                <div style={{ color: "red", fontSize: "11px" }}>{nextActionError}</div>
                            </div>

                            <div className="form-group">
                                <label>Next Action Date & Time</label>
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={nextActionDate || ''}
                                    onChange={(e) => nextActionDateFn(e.target.value)}
                                />
                                <div style={{ color: "red", fontSize: "11px" }}>{nextActionDateError}</div>
                            </div>
                        </div>
                    }
                />
            </ErrorBoundary>
            {/* ========add activity modal end===== */}
        </>
    );
};



const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        websocket: globalState.mainReducerData.websocket,
        tabGridLabel: globalState.LoginReducer.tabGridLabel, // for control pannel added,
        localTimeZoneName: globalState.mainReducerData.localTimeZone,
    };
}


export default withRouter(connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp, connectToWebsocket, disconnectToWebsocket })
    (withTranslation()(TaskListPopup)));

// export default TaskListPopup;
